export default __webpack_public_path__ + "static/menu-d8dbfaf927da3d5ca8ecb6ac100cdfde.jpg";